import { Box, CircularProgress } from '@mui/material';

export const Loader = () => {
  return (
    <Box
      sx={({ palette }) => ({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: palette.grey[500],
        opacity: 0.5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2,
      })}
    >
      <CircularProgress color='warning' size={60} />
    </Box>
  );
};
